import React from 'react'
import { Line } from 'react-chartjs-2'

class LineChart extends React.Component {
    render () {
        const getMax = () => {
            return Math.ceil((Math.max.apply(Math, this.props.data) + 1) / 10) * 10
        }

        const makeLabel = (value) => {
            if (this.props.unit && this.props.unit === '$') {
                return `$${value.toFixed(2)}`
            } else {
                return `${value} GB`
            }
        }

        const data = {
            labels: this.props.labels,
            datasets: (this.props.datasets
                ? this.props.datasets
                : [
                    {
                        label: false,
                        fill: false,
                        lineTension: 0,
                        backgroundColor: 'rgba(99,212,129,0.4)',
                        borderColor: '#63D481',
                        pointRadius: 6,
                        pointHoverRadius: 6,
                        pointBorderColor: '#63D481',
                        pointHoverBorderColor: '#63D481',
                        pointBackgroundColor: '#fff',
                        pointHoverBackgroundColor: '#63D481',
                        pointBorderWidth: 3,
                        pointHoverBorderWidth: 3,
                        data: this.props.data ? this.props.data : []
                    }
                ])
        }

        const options = {
            legend: {
                display: !!this.props.legend,
                labels: {
                    fontFamily: 'engrezregular'
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    ticks: {
                        fontColor: '#5e5e5e',
                        fontSize: 14,
                        fontFamily: 'engrezregular'
                    }
                }],
                yAxes: [{
                    display: true,
                    ticks: {
                        suggestedMin: 0,
                        suggestedMax: getMax(),
                        fontColor: '#5e5e5e',
                        fontFamily: 'engrezregular'
                    },
                    scaleLabel: {
                        display: true,
                        labelString: this.props.unit && this.props.unit === '$' ? '$' : 'GB',
                        fontColor: '#5e5e5e',
                        fontSize: 16,
                        fontFamily: 'engrezbold'
                    }
                }]
            },
            tooltips: {
                backgroundColor: '#004346',
                xPadding: 10,
                yPadding: 10,
                bodyFontSize: 16,
                titleFontSize: 16,
                displayColors: false,
                intersect: false,
                callbacks: {
                    label: (tooltipItems, data) => {
                        return makeLabel(tooltipItems.yLabel)
                    },
                    title: (tooltipItems, data) => {
                        return ''
                    }
                }
            }
        }

        return (
            <div className='line-chart-wrapper'>
                {this.props.title ? <h2 className='text-center color-indigo'>{this.props.title}</h2> : ''}
                <Line data={data} options={options} />
                {this.props.children}
            </div>
        )
    }
}

export default LineChart



// WEBPACK FOOTER //
// ./resources/js/components/LineChart.js